import { Icon, type IconProps } from './Icon';

export function Pencil(props: IconProps) {
    return (
        <Icon viewBox="0 0 28 28" strokeWidth={1.73107} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.10864 18.0248L18.0254 6.10807C18.4754 5.65799 19.2059 5.65799 19.656 6.10807L21.5902 8.04225C22.0403 8.49233 22.0403 9.22285 21.5902 9.67292L9.67235 21.5885C9.45654 21.8054 9.16341 21.9266 8.85759 21.9266H5.77051V18.8395C5.77051 18.5337 5.89168 18.2406 6.10864 18.0248Z"
            />
            <path d="M15.8682 8.2627L19.4342 11.8287" />
        </Icon>
    );
}